<div class="w-full h-full bg-base-200"></div>
<dialog #age_modal class="modal focus:outline-none">
  <div
    class="modal-box w-full h-full py-5 px-0 xl:p-6 max-w-none max-h-full xl:h-fit xl:max-w-[420px] rounded"
  >
    <div class="flex flex-col p-5 xl:p-4 gap-8 items-center">
      <svg-icon
        src="/assets/images/gingr_logo.svg"
        [svgStyle]="{
          'width.px': 150,
          'height.px': 60
        }"
      ></svg-icon>
      <span
        class="text-[24px] text-primary font-semibold first-letter:capitalize"
        >{{ 'ACCOUNT.AGE.age verification' | translate: locale.language }}</span
      >
      <span class="text-center">{{
        'ACCOUNT.AGE.age verification description 2'
          | translate: locale.language
      }}</span>
      <div class="flex flex-col gap-2.5 w-full text-center">
        <div
          (click)="over18()"
          class="cursor-pointer rounded bg-primary text-secondary-content font-medium w-full py-[18px] px-6"
        >
          {{ 'ACCOUNT.AGE.age verification yes' | translate: locale.language }}
        </div>
        <div
          (click)="under18()"
          class="cursor-pointer rounded bg-primary text-secondary-content font-medium w-full py-[18px] px-6"
        >
          {{ 'ACCOUNT.AGE.age verification no' | translate: locale.language }}
        </div>
      </div>
      <div class="flex">
        <span
          (click)="closeModal('/info/terms')"
          class="text-primary focus:outline-none first-letter:capitalize cursor-pointer"
          >{{ 'INFO.Terms & conditions' | translate: locale.language }}</span
        ><span class="inline-block ms-1 me-1">{{
          'ACCOUNT.AGE.and' | translate: locale.language
        }}</span
        ><span
          (click)="closeModal('/info/privacy-policy')"
          class="text-primary focus:outline-none cursor-pointer"
          >{{ 'INFO.Privacy policy' | translate: locale.language }}</span
        >
      </div>
    </div>
  </div>
</dialog>
